<div class="audit-container" *ngIf="attachmentCount > 0">
  <div (click)="onDownloadAllAttachment()" class="downloadAllButton">
    <img [src]="'assets/Inbox/downloadBlue.svg'" alt="Download" />
    <div class="downloadAllText">Download All</div>
  </div>
</div>
<app-attachment-dialog #attachViewer [isMobile]="false"></app-attachment-dialog>
<div class="container attachment-list" *ngIf="attachmentCount > 0">
  <div class="d-flex flex-column">
    <ng-template ngFor let-attachment [ngForOf]="attachmentList">
      <div class="fileItem">
        <div>
          <img [src]="getFileIcon(attachment.name)" alt="FileType" />
        </div>
        <div class="fileDescBox" >
          <div class="attach-name" title="{{attachment.name}}" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
            {{attachment.name}}
          </div>
          <div class="attach-time">
            {{attachment.time | date:'dd MMM hh:mm a'}}
          </div>
        </div>
        <div class=" attach-download">
          <img
            class="default-icon"
            [src]="'assets/Inbox/downloadBlack.svg'"
            alt="Download"
            (click)="onDownloadAttachment(attachment)"
            pTooltip="Download"
            tooltipPosition="top"
            tooltipStyleClass="rightTooltip p-tooltip-text"
          />
        </div>
        <div class="icon-divider"></div>
        <div class="copy-icon-container">
          <img
            class="defaulCopyIcon"
            src="assets/Inbox/copyDefault.svg"
            alt="Copy"
            name="copy"
            (click)="onCopyAttachment(attachment)"
            title="{{attachment?.copiedMsg}}"
            pTooltip="Copy"
            tooltipPosition="top"
            tooltipStyleClass="rightTooltip p-tooltip-text"
          />
          <img
            class="hoverCopyIcon"
            src="assets/Inbox/copyHover.svg"
            alt="Copy"
            name="copy"
            (click)="onCopyAttachment(attachment)"
            title="{{attachment?.copiedMsg}}"
            pTooltip="Copy"
            tooltipPosition="top"
            tooltipStyleClass="rightTooltip p-tooltip-text"
          />
        </div>
        <div class="icon-divider"></div>
        <div class="attach-download">
          <img
            class="default-icon"
            src="assets/Inbox/attachmentView.svg"
            alt="Copy"
            name="copy"
            (click)="onViewctionRedesigned(attachment)"
            title="{{attachment?.copiedMsg}}"
            pTooltip="View"
            tooltipPosition="top"
            tooltipStyleClass="rightTooltip p-tooltip-text"
          />
        </div>
      </div>
    </ng-template>
  </div>
</div>
